import { SelectSuggest } from '@cms/tpl';
import { Input } from 'antd';
import { CONTAINER } from 'common';
import MonthPicker from 'components/monthpicker/MonthPicker';
import React from 'react';
import OptionService from 'services/OptionService';
import { COMMON_ELEMENTS } from '../Utils';
import ExportCommonIndex from '../index';
const container = CONTAINER.EXPORT_CONTRACT_REVENUE;
const elements = () => {
  const cols = [
    {
      size: 12,
      elements: [
        {
          label: 'Tháng',
          name: 'month',
          input: <MonthPicker />,
        },
        {
          label: 'Đối tác',
          name: 'businessPartnerId',
          input: (
            <SelectSuggest suggestApi={OptionService.getBusinessPartners} />
          ),
        },

        {
          label: 'Số hợp đồng',
          name: 'contractNumber',
          input: <Input />,
        },
      ],
    },
    COMMON_ELEMENTS(container, true, false, [
      'Tháng',
      'Số hợp đồng',
      'Đối tác',
      'Lượt nghe',
      'Doanh thu',
      'MG còn lại',
      'Doanh thu cam kết',
      'Doanh thu chia sẻ',
      'Tình trạng thanh toán',
      'Loại hợp đồng',
    ]),
  ];
  return [{ cols }];
};
const ExportContractRevenueIndex = () => {
  return (
    <ExportCommonIndex
      formElements={elements()}
      title={'Doanh thu hợp đồng'}
      container={container}
      hidePreview
    />
  );
};

export default ExportContractRevenueIndex;
